import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFolderOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 19 12"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M16.469 5c1.187 0 1.906 1.313 1.281 2.313l-2.5 4A1.48 1.48 0 0 1 14 12H1.5A1.48 1.48 0 0 1 0 10.5v-9A1.5 1.5 0 0 1 1.5 0h5l2 2h5c.813 0 1.5.688 1.5 1.5V5zM1.5 1.688V9l1.938-3.25c.28-.469.78-.75 1.312-.75h8.75V3.688a.2.2 0 0 0-.187-.188H7.875l-2-2H1.688c-.125 0-.188.094-.188.188M14 10.5l2.5-4H4.656l-2.406 4z"
    />
  </svg>
);
export default SvgFolderOpen;
